import 'babel-polyfill';
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import api from './api'; // 导入api接口
import * as utils from './utils';
import './assets/styles/main.css';
import './assets/styles/custom.css';
import Echarts from 'echarts'; // 引入echarts
import _ from 'lodash';
import video from './utils/video';
import 'video.js/dist/video-js.css';
import moment from 'moment'; // 导入时间处理模块
import VueCookies from 'vue-cookies';

Vue.use(ElementUI);
Vue.use(VueCookies);

Vue.prototype._ = _; // 引入lodash
Vue.prototype.$api = api; // 将api挂载到vue原型上
Vue.prototype.$utils = utils;
Vue.prototype.$echarts = Echarts; // 引入组件
Vue.config.productionTip = false;
Vue.prototype.$video = video; // 引入video.js

moment.locale('zh-cn'); // 设置语言 或 moment.lang('zh-cn');
Vue.prototype.$moment = moment; // 赋值使用

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
